import React from 'react'
import { i18n } from '@fs/zion-locale'
import { baseUrl } from '@fs/zion-config'
import { getCustomImage } from '../helpers'
import StructuredData from './StructuredData'
import { familySearchLogoColorSvg, rootsTechByFamilySearchLightSvg } from '../../images'
import { stripHtml } from '../../api/helpers'
import mapSocialAccounts from './helpers'

const getImageObjectData = (data) => {
  const image = getCustomImage(data)
  if (!image) return undefined
  return {
    '@type': 'ImageObject',
    url: image,
    // width: image.width,
    // height: image.height,
    // caption: image.caption || '',
  }
}

const getContactPointData = (data) => {
  if (!data?.companySupportUrl) return undefined
  return {
    '@type': 'ContactPoint',
    contactType: 'Customer Support',
    url: data.companySupportUrl,
    availableLanguage: 'English',
  }
}

const getChurchOrganizationData = () => {
  return {
    '@type': 'Organization',
    name: 'The Church of Jesus Christ of Latter-day Saints',
    url: 'https://www.churchofjesuschrist.org/',
    logo: 'https://www.churchofjesuschrist.org/content/dam/church/friends/images/latter-day-saints-logo.svg',
    description:
      'The Church of Jesus Christ of Latter-day Saints is a denomination headquartered in Salt Lake City, Utah, with congregations and temples worldwide, founded in 1830 by Joseph Smith.',
    foundingDate: '1830-04-06',
    founder: {
      '@type': 'Person',
      name: 'Joseph Smith',
    },
    areaServed: 'Worldwide',
    sameAs: [
      'https://en.wikipedia.org/wiki/The_Church_of_Jesus_Christ_of_Latter-day_Saints',
      'https://www.facebook.com/ChurchofJesusChrist/',
      'https://twitter.com/ChurchOfJesusChrist',
      'https://www.instagram.com/churchofjesuschrist/',
      'https://www.youtube.com/churchofjesuschrist',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'information',
      availableLanguage: 'en',
      email: 'info@churchofjesuschrist.org',
    },
  }
}

const getFamilySearchOrganizationData = () => {
  return {
    '@type': 'Organization',
    name: 'FamilySearch International',
    url: baseUrl,
    alternateName: 'Genealogical Society of Utah',
    logo: familySearchLogoColorSvg,
    description:
      'FamilySearch International is a nonprofit and volunteer-driven organization offering free genealogical records, resources, and services to help people discover, preserve, and share their family history.',
    foundingDate: '1894-11-13',
    sameAs: [
      'https://en.wikipedia.org/wiki/FamilySearch',
      'https://www.facebook.com/familysearch/',
      'https://www.instagram.com/familysearch/',
      'https://x.com/familysearch',
      'https://www.youtube.com/@familysearch',
    ],
    parentOrganization: getChurchOrganizationData(),
    // logo: {
    //   '@type': 'ImageObject',
    //   url: 'https://www.familysearch.org/rootstech/static/images/logo.png',
    // },
  }
}

export const getOrganizationData = (data) => {
  if (!data || Object.keys(data).length === 0) return null
  const isRootsTech = data.name === 'RootsTech'
  const isFamilySearch = data.name === 'FamilySearch'

  let parentOrganization
  if (isRootsTech) {
    parentOrganization = getFamilySearchOrganizationData()
  } else if (isFamilySearch) {
    parentOrganization = getChurchOrganizationData()
  }

  return {
    '@type': 'Organization',
    name: data.name || data.title,
    description: stripHtml(data.companyDescription) || data.description || undefined,
    url: data.companyWebsite?.url || data.url,
    sameAs: data.socialAccounts ? mapSocialAccounts(data.socialAccounts, true) : undefined,
    logo: getImageObjectData(data),
    email: data.companyContactEmail,
    parentOrganization,
    contactPoint: getContactPointData(data),
  }
}

export const getRootsTechOrganizationData = (includeParent = true) => {
  return {
    '@type': 'Organization',
    name: 'RootsTech',
    url: `${baseUrl}/rootstech/`,
    logo: rootsTechByFamilySearchLightSvg,
    description: i18n.t(
      'structured-data.rootstech.organization.description',
      'RootsTech is the world’s largest family history conference, bringing together people from around the globe to learn, connect, and share their family history stories.'
    ),
    sameAs: [
      'https://en.wikipedia.org/wiki/RootsTech',
      'https://www.facebook.com/RootsTech/',
      'https://www.instagram.com/rootstechconf/',
      'https://x.com/RootsTechConf',
      'https://www.youtube.com/RootsTechConf',
    ],
    parentOrganization: includeParent ? getFamilySearchOrganizationData() : undefined,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'information',
      availableLanguage: 'en',
      email: 'info@rootstech.org',
    },
  }
}

export default function OrganizationStructuredData({ data }) {
  if (!data || Object.keys(data).length === 0) return null
  const structuredData = getOrganizationData(data)

  return <StructuredData data={structuredData} dataTestId="organization-structured-data" />
}
